import React, { useState, useEffect } from "react";
import { LockOpen, InsertDriveFile } from "@mui/icons-material";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
} from "@mui/material";
import "./login.css";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import iconVU from "../../assets/logo.webp";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginStatus, setLoginStatus] = useState("");

  const navigation = useNavigate();

  const handleLogin = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      username: username,
      password: password,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
      // header("Access-Control-Allow-Headers: Content-Type");
    };

    fetch(
      `https://i.vu.ac.th/php_api/volunteer_login_api`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === "ok" && result.user_type === 1) {
          Swal.fire({
            icon: "success",
            title: "เข้าสู่ระบบสำเร็จ",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              title: "thai-font",
            },
          });
          localStorage.setItem("token", result.pass);
          const ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify({
              fullname: result.fullname,
              user_id: result.user_id,
              fac_name: result.fac_name,
              maj_name: result.maj_name,
              job_name: result.job_name,
            }),
            "secret key 123"
          ).toString();
          const url = `/student_dashboard?q=${encodeURIComponent(ciphertext)}`;
          navigation(url);
        } else if (result.status === "ok" && result.user_type === 2) {
          if (result.user_id === "2545001" || result.user_id === "2555010") {
            Swal.fire({
              icon: "success",
              title: "เข้าสู่ระบบสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            localStorage.setItem("token", result.pass);
            const ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify({
                fullname: result.fullname,
                user_id: result.user_id,
                department: result.department,
              }),
              "secret key 123"
            ).toString();
            const url = `/approver_dashboard?q=${encodeURIComponent(
              ciphertext
            )}`;
            navigation(url);
          } else {
            Swal.fire({
              icon: "success",
              title: "เข้าสู่ระบบสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            localStorage.setItem("token", result.pass);
            const ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify({
                fullname: result.fullname,
                user_id: result.user_id,
                department: result.department,
              }),
              "secret key 123"
            ).toString();
            const url = `/teacher_dashboard?q=${encodeURIComponent(
              ciphertext
            )}`;
            navigation(url);
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "Username หรือ Password ไม่ถูกต้อง",
          });
          setLoginStatus(result.message);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login-page">
      <div className="bg-color">
        <Container
          maxWidth="sm"
          style={{ backgroundColor: "#fff", borderRadius: 50, padding: 10 }}
          className="thai-font login_contianer"
        >
          <div>
            <div className=" d-flex justify-content-center">
            <img
              className="img-fluid shadow-2-strong"
              src={iconVU}
              alt="VU Logo"
            />
            </div>
            
            <h2
              className="fw-bold mb-2 text-center thai-font"
              style={{ fontSize: 40 }}
            >
              ระบบบันทึกจิตอาสา
            </h2>
            <h3
              className=" mb-2 text-center thai-font text-color"
              style={{ fontSize: 36, fontWeight: "bold" }}
            >
              VU Volunteer
            </h3>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <form style={{ width: "80%" }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="ชื่อผู้ใช้"
                name="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="รหัสผ่าน"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyPress}
              />
              <Button
                fullWidth
                variant="contained"
                startIcon={<LockOpen />}
                className="loginBtn thai-font"
                style={{
                  marginTop: 20,
                  fontFamily: "'TH Sarabun', sans-serif",
                  fontSize: 24,
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => handleLogin()}
              >
                เข้าสู่ระบบ
              </Button>
              {loginStatus && (
                <div style={{ marginTop: 20, color: "red" }}>{loginStatus}</div>
              )}
            </form>
          </div>
          <hr className="mt-5" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button
              startIcon={<InsertDriveFile />}
              variant="contained"
              color="success"
              style={{ marginLeft: 10, borderRadius: 10 }}
              disableElevation
              onClick={() =>
                window.open(
                  "https://docs.google.com/presentation/d/1W5PwbFeXWxLcV0izYM6x0QM6S7VO6A5qwO2XP2HBoWM/edit?usp=sharing"
                )
              }
            >
              คู่มือการใช้งาน-สำหรับนักศึกษา
            </Button>
            <Button
              startIcon={<InsertDriveFile />}
              variant="contained"
              color="warning"
              style={{ marginLeft: 10, borderRadius: 10, marginTop: 10 }}
              disableElevation
              onClick={() =>
                window.open(
                  "https://docs.google.com/presentation/d/156BvJDb0ggXcfWFIfTXZq71EGI1Y5XwNygoov6zLpb8/edit?usp=sharing"
                )
              }
            >
              คู่มือการใช้งาน-สำหรับคณะวิชา ศูนย์สำนัก
            </Button>
            <Button
              startIcon={<InsertDriveFile />}
              variant="contained"
              color="info"
              style={{ marginLeft: 10, borderRadius: 10, marginTop: 10 }}
              disableElevation
              onClick={() =>
                window.open(
                  "https://docs.google.com/presentation/d/1qPpWFiFVxO18a6VtZFOs0MBhXjTPmki-eH0y7blLInQ/edit?usp=sharing"
                )
              }
            >
              คู่มือการใช้งาน-สำหรับผู้พิจารณา
            </Button>
          </div>
        </Container>
      </div>
    </div>
  );
}
